import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { fetchData } from "../../helpers/getData/fetchData";
import { SendNotifications } from "./SendNotifications";
import { Loading } from "../generals/Loading";

export const GetUsersWrapper = ({
  formValues,
  handleInputChange,
  startupId,
  userWhithReservation,
}) => {
  const { t } = useTranslation("global");

  const [userList, setuserList] = useState([]);
  const [userWithActivePosition, setUserWithActivePosition] = useState([]);

  useEffect(() => {
    fetchData(setuserList, `/user`, t);
  }, [t]);

  useEffect(() => {
    fetchData(
      setUserWithActivePosition,
      `/user/getUsersWithActivePosition/${startupId}`,
      t
    );
    // eslint-disable-next-line no-undef, react-hooks/exhaustive-deps
  }, []);

  if (userList.length < 1) {
    return <Loading />;
  }

  const finalUserList = userList.filter(
    (user) =>
      (user.role === "Club" || user.role === "Híbrido") &&
      !userWhithReservation.includes(user.idCrm)
  );

  if (userList.length > 0) {
    return (
      <SendNotifications
        formValues={formValues}
        handleInputChange={handleInputChange}
        userList={finalUserList}
        userWithActivePosition={userWithActivePosition}
      />
    );
  }
};
